import { css } from '@/styled-system/css';

export const flexContainerStyles = css.raw({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: '{spacing.600} {spacing.400}',
  marginBottom: '200',
  border: '1px solid {colors.border.subtle}',
  boxSizing: 'border-box',
  borderRadius: '100',
  cursor: 'pointer',
  height: '100%',
  minHeight: '116px',
  '&:hover': {
    backgroundColor: 'bg.action.soft.default',
    border: '1px solid {colors.border.accent.brand.hero}',
  },
});
